import React, { Component, Fragment } from 'react'
import Uppy from '@uppy/core'
import { Dashboard } from '@uppy/react'
import Tus from '@uppy/tus'
import { TUSD_HOST } from '../config'
import '../assets/styles/uppy.css'
import { GET_PROFILE, UPLOAD_SUCCESS } from '../actions'
import authProvider from '../authProvider'

class Upload extends Component {
  constructor (props) {
    super(props)

    this.state = {
      modalOpen: false
    }

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)

    const profile = JSON.parse(localStorage.getItem('profile')) || {}
    const { userId, email } = profile
    console.log(userId)
    this.uppy = Uppy({
      id: 'uppy',
      autoProceed: true,
      debug: true,
      restrictions: {
        maxFileSize: false,
        maxNumberOfFiles: false,
        minNumberOfFiles: false,
        allowedFileTypes: false
      }
    })
    this.uppy.use(Tus, { endpoint: TUSD_HOST })
    this.uppy.setState({
      meta: { userId: userId }
    })
    this.uppy.on('complete', (result) => {
      console.log('successful files:', result.successful)
      console.log('failed files:', result.failed)
      console.log('user id sccuess: ', userId)
      authProvider(GET_PROFILE).then(profile => {
        console.log(profile)
        authProvider(UPLOAD_SUCCESS, result.successful)
      })
    })
  }

  handleOpen () {
    this.setState({
      modalOpen: true
    })
  }

  handleClose () {
    this.setState({
      modalOpen: false
    })
  }

  render () {
    // const { profile } = this.props
    // const { userId, email } = profile
    // const profile = localStorage.getItem('profile')
    // const { userId, email } = profile
    return (
      <Fragment>
        <Dashboard
          uppy={this.uppy}
          plugins={[]}
          />
      </Fragment>
    );
  }
}

// Upload.defaultProps = {
//   profile: {}
// }

export default Upload



// WEBPACK FOOTER //
// ./src/components/Upload.js